<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <v-layout class="section-header mx-2" row wrap align-content-center justify-center>
        <v-flex xs12>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-headset</v-icon>
              Financeiro
            </h1>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 md4>
      <div class="section-box text-xs-center section-widget">
        <span class="number blue--text">-</span>
        <h2 class="section-title">SALDO</h2>
      </div>
    </v-flex>
    <v-flex xs12 md4>
      <div class="section-box text-xs-center section-widget">
        <span class="number teal--text">-</span>
        <h2 class="section-title">A RECEBER</h2>
      </div>
    </v-flex>
    <v-flex xs12 md4>
      <div class="section-box text-xs-center section-widget">
        <span class="number deep-orange--text">-</span>
        <h2 class="section-title">ATRASADO</h2>
      </div>
    </v-flex>

    <v-flex xs12>
      <v-layout class="section-header my-3 mx-2" row wrap align-content-center justify-center>
        <v-flex xs12>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-usd-circle</v-icon>
              Planos
            </h1>
          </v-layout>
        </v-flex>
      </v-layout>
      <financial-plans-list></financial-plans-list>
    </v-flex>

    <v-flex xs12 v-if="!transactions.length">
      <empty-alert :icon="'sync'" :color="'orange accent-4'" v-if="!transactions.length">
        <div slot="content">
          <p><strong>Nenhuma transação encontrada.</strong></p>
        </div>
      </empty-alert>
    </v-flex>

    <v-flex xs12 v-if="transactions.length">
      <v-layout class="section-header my-3 mx-2" row wrap align-content-center justify-center>
        <v-flex xs12 lg4>
          <v-layout row wrap align-center>
            <h1 class="section-title">
              <v-icon color="deep-orange darken-2">fal fa-sync</v-icon>
              Últimas transações
            </h1>
          </v-layout>
        </v-flex>
        <v-flex xs12 lg8>
          <v-layout row wrap justify-end>
            <v-text-field v-model="search" class="search-input" label="Buscar"
              append-icon="fal fa-search"></v-text-field>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 v-if="transactions.length">
      <v-data-table
        class="section-box"
        width="100%"
        :headers="headers"
        :items="transactions"
        :search="search"
        sort-icon="fal fa-arrow-down"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td>
            <strong v-if="props.item.collection.cardholder.name">
              {{ props.item.collection.cardholder.name }}
            </strong>
            (ID: {{ props.item.collection.id }})
          </td>
          <td>
            {{ props.item.collection.transaction_amount | formatCurrency }}
            <!-- ({{ props.item.collection.transaction_details.net_received_amount | formatCurrency }}) -->
          </td>
          <td>{{ props.item.collection.status }}</td>
          <td>
            <v-tooltip bottom>
              <span slot="activator">{{ props.item.collection.date_created | moment('DD/MM/Y') }}</span>
              <span>{{ props.item.collection.date_created | moment('DD/MM/Y, HH:mm') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-btn flat icon color="grey darken-2" dark
              v-modal-trigger="'showSubscriptionsDetail'" :data-item="JSON.stringify(props.item.collection)">
              <v-icon small>fa fa-ellipsis-v</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="black" outline>
            Nenhuma transação encontrada.
          </v-alert>
        </template>
        <template slot="no-data">
          <div class="my-3 text-xs-center">
            Nenhuma transação encontrada.
          </div>
        </template>
      </v-data-table>
    </v-flex>
    <admin-subscriptions-detail></admin-subscriptions-detail>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import router from '@/router'

import FinancialPlansList from '@/components/admin/financial/FinancialPlansList'
import AdminSubscriptionsDetail from '@/components/admin/financial/AdminSubscriptionsDetail'

export default {
  data: () => ({
    search: '',
    router: router,
    currentFilter: 'all',
    headers: [
      { text: 'Aluno', value: 'payer.first_name' },
      { text: 'Valor', value: 'transaction_amount', width: '300' },
      { text: 'Status', value: 'status', width: '100' },
      { text: 'Data', value: 'date_created', width: '200' },
      { text: '', value: '', width: '100', sortable: false }
    ],
    transactions: []
  }),

  methods: {
    loadTransactions () {
      const path = `${API.mpPayments}/search?collector.id=me`
      axios.post(path).then(response => {
        this.transactions = []
        this.transactions = response.data.payments.response.results
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
      })
    },

    loadBalance () {
      const path = `${API.mpBalance}`

      axios.get(path).then(response => {
        console.log(response)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
      })
    },

    loadSubscriptions () {
      const path = `${API.mpSubscriptions}/search`

      axios.get(path).then(response => {
        console.log(response)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: errors.response.data.message, color: 'error' })
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadTransactions')
  },

  created () {
    EventBus.$on('loadTransactions', this.loadTransactions)
    this.loadTransactions()
    this.loadBalance()
    // this.loadSubscriptions()
  },

  components: {
    FinancialPlansList,
    AdminSubscriptionsDetail
  }
}
</script>

<style src="../../assets/scss/components/overview.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/admin/AdminFinancial.vue